import React from "react";
import VersionTable from "../../components/tables/VersionsTable";
import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { SYSTEM_LANGUAGE_LABELS } from "../../shared/enums/shared-enums";
import { Version } from "../../types/version";

interface MainVersionPageProps {
  systemLanguageType: Version["system_language_type"];
}

const MainVersionPage: React.FC<MainVersionPageProps> = ({
  systemLanguageType,
}) => {
  const navigate = useNavigate();
  const languageLabel = SYSTEM_LANGUAGE_LABELS[systemLanguageType];

  return (
    <Box>
      <Box
        sx={{
          mb: 4,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{
            position: "absolute",
            left: 16,
          }}
          startIcon={<AddIcon />}
          onClick={() => navigate("create")}
        >
          Create Version
        </Button>

        <Typography variant="h1">
          {languageLabel ? `${languageLabel} Versions` : "Versions"}
        </Typography>
      </Box>
      <VersionTable filters={{ system_language_type: systemLanguageType }} />
    </Box>
  );
};

export default MainVersionPage;
